<template>
    <el-form label-position="top" :rules="rules" ref="ruleFormRef" :model="values" @submit.prevent>
        <el-form-item label="İstisnanın kodu" class="w-50" prop="exceptCode" label-position="top">
            <el-input v-model="this.values.exceptCode" />
        </el-form-item>
        <el-form-item label="İstisna" prop="exceptName" label-position="top">
            <el-input v-model="this.values.exceptName" />
        </el-form-item>
        <div class="row dialog-btn">
            <div>
                <soft-button @click="InsertExceptionType()" color="success">
                    {{ !this.editing ? 'Daxil et' : 'Qəbul et' }}</soft-button>
                &nbsp;
                <soft-button @click="this.$emit('close-dialog')" color="secondary">Imtina</soft-button>
            </div>
        </div>
    </el-form>
</template>
<script>
import SoftButton from "@/components/SoftButton.vue";

export default {
    components: {
        SoftButton
    },
    props: {
        editing: Boolean,
        object: Object
    },
    data() {
        return {
            values: {},
            rules: {
                exceptCode: [{ required: true, message: 'Mütləq sahə', trigger: 'change' }],
                exceptName: [{ required: true, message: 'Mütləq sahə', trigger: 'change' }],
            }
        }
    },
    methods: {
        InsertExceptionType() {
            this.$refs.ruleFormRef.validate(valid => {
                if (valid) {
                 //None
                }
            })
        },
    },
    mounted() {
        if (this.editing) {
            this.values = { ...this.object }
        }
    },
}
</script>